import axios from 'axios';

class SettlementService {
    constructor() {
        this.baseURL = `${import.meta.env.VITE_API_BASE_URL}/cpanel/settlements`;
    }

    async getSettlements(params = {}) {
        try {
            const queryParams = { ...params };

            const response = await axios.get(this.baseURL, {
                params: queryParams,
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch settlements');
            throw error;
        }
    }

    async getSettlement(uuid) {
        try {
            const response = await axios.get(`${this.baseURL}/${uuid}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch settlement');
            throw error;
        }
    }

    async createSettlement(settlementData) {
        try {
            const response = await axios.post(this.baseURL, settlementData, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to create settlement');
            throw error;
        }
    }

    async calculateSettlement(uuid) {
        try {
            const response = await axios.post(
                `${this.baseURL}/${uuid}/calculate`,
                {},
                {
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to calculate settlement');
            throw error;
        }
    }

    async approveSettlement(uuid) {
        try {
            const response = await axios.post(
                `${this.baseURL}/${uuid}/approve`,
                {},
                {
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to approve settlement');
            throw error;
        }
    }

    async markSettlementPaid(uuid) {
        try {
            const response = await axios.post(
                `${this.baseURL}/${uuid}/mark-paid`,
                {},
                {
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to mark settlement as paid');
            throw error;
        }
    }

    handleError(error, message) {
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;

            switch (status) {
                case 400:
                    console.error(`${message}: Invalid data`, data);
                    break;
                case 401:
                    console.error(`${message}: Authentication required`);
                    break;
                case 404:
                    console.error(`${message}: Resource not found`);
                    break;
                case 500:
                    console.error(`${message}: Server error`, data);
                    break;
                default:
                    console.error(`${message}: HTTP ${status}`, data);
            }
        } else if (error.request) {
            console.error(`${message}: Network error`, error.request);
        } else {
            console.error(`${message}:`, error.message);
        }
    }
}

const settlementService = new SettlementService();
export default settlementService;
